import { useSite } from '@on3/ui-lib/index';

import { PerkChecklistItem } from './Item/PerkChecklistItem';
import styles from './PerkChecklist.module.scss';

interface IPerkChecklistProps {
  siteBullets?: string[] | null;
}
export const PerkChecklist = ({ siteBullets }: IPerkChecklistProps) => {
  const { currentSite } = useSite();
  const siteName = currentSite?.name ?? 'On3';
  const isSoftballAmerica = currentSite?.key === 401;
  const orgName =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name ?? '';
  const mascot = currentSite?.organization?.mascot ?? ``;
  const isTeam = currentSite?.isTeam;
  const appText = isTeam
    ? `${siteName} Mobile App with Alerts`
    : `On3 ${orgName} ${mascot} Mobile App with Alerts`;

  return (
    <section className={styles.block}>
      <h2>Membership Benefits</h2>
      <ul>
        {siteBullets?.map((bullet, index) => (
          <PerkChecklistItem key={index} label={bullet} />
        ))}
        {!isTeam && (
          <PerkChecklistItem label="Premium content from the On3 News Desk" />
        )}
        <PerkChecklistItem label="Reduced Ad experience" />
        <PerkChecklistItem label="Daily Email Newsletter" />
        {!isSoftballAmerica && <PerkChecklistItem label={appText} />}
      </ul>
    </section>
  );
};
